import React from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import Form from "../components/Form";
import Cont from "../components/Cont";

import Certifications from "../components/Certifications";

export default function Contact() {
  return (
    <>
      <Navibar />
      <Cont
        Mail="info@vsktextiles.com"
        Address="•	Registered Office: Chennai, India.  
                 •	Factory Address: Kovilpatti, Tuticorin, Tamil Nadu, India.
                 •	Marketing Office: Coimbatore, Tamil Nadu, India."
        MapIn="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3938.4559244781053!2d77.81521497664096!3d9.20345118623053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06b1f9bdfa1419%3A0x96519e290fe38949!2sVSK%20TEXTILES%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1734871200325!5m2!1sen!2sin"
      />
      <Form />
      <Certifications />
      <Footer />
    </>
  );
}
